// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function $$boolean(json, key) {
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, key));
  if (value !== undefined) {
    return value;
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_publication_response"
    });
}

function optional(decode, value) {
  if (Caml_obj.caml_equal(value, null)) {
    return;
  } else {
    return Caml_option.some(Curry._1(decode, value));
  }
}

function decode_pr(json) {
  const number = Mapre_wire__Json.integer(json, "number");
  const url = Mapre_wire__Json.string(json, "url");
  if (number < 1 || !Stdlib__String.starts_with("https://github.com/", url) || !Stdlib__String.for_all((function (c) {
      if (c > 32) {
        return c < 127;
      } else {
        return false;
      }
    }), url)) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_publication_url"
      });
  }
  return {
    number,
    url
  };
}

function decode_publication(json) {
  return {
    id: Mapre_wire__Json.string(json, "id"),
    run_id: Mapre_wire__Json.string(json, "run_id"),
    phase: Mapre_wire__Json.string(json, "phase"),
    branch: Mapre_wire__Json.string(json, "branch"),
    commit: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "commit_sha")),
    receipt_state: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "receipt_state")),
    pr: optional(decode_pr, Mapre_wire__Json.get(json, "pr")),
    uncertain: $$boolean(json, "uncertain")
  };
}

function decode(json) {
  const match = Mapre_wire__Json.string(json, "destination");
  let tmp;
  switch (match) {
    case "branch" :
      tmp = true;
      break;
    case "pull_request" :
      tmp = false;
      break;
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_publication_destination"
        });
  }
  return {
    run_id: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "run_id")),
    version: Mapre_wire__Json.integer(json, "version"),
    can_publish: $$boolean(json, "can_publish"),
    can_stop: $$boolean(json, "can_stop"),
    stop_requested: $$boolean(json, "stop_requested"),
    branch_only: tmp,
    publication: optional(decode_publication, Mapre_wire__Json.get(json, "publication")),
    cleanup: Stdlib__Option.value(Js__Js_json.decodeString(Mapre_wire__Json.get(json, "cleanup_state")), ""),
    failure: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "failure_code"))
  };
}

function update(t, title) {
  if (/* tag */ typeof title !== "object" && typeof title !== "function") {
    switch (title) {
      case /* Denied */ 0 :
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: undefined,
          message: "Permission denied. Refresh access before publishing.",
          denied: true
        };
      case /* Access_refreshed */ 1 :
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: t.attempt,
          message: "",
          denied: false
        };
      default:
        return t;
    }
  } else {
    switch (title.TAG) {
      case /* Title */ 0 :
        return {
          control: t.control,
          title: title._0,
          body: t.body,
          initialized: true,
          attempt: t.attempt,
          message: t.message,
          denied: t.denied
        };
      case /* Body */ 1 :
        return {
          control: t.control,
          title: t.title,
          body: title._0,
          initialized: t.initialized,
          attempt: t.attempt,
          message: t.message,
          denied: t.denied
        };
      case /* Default_title */ 2 :
        if (t.initialized) {
          return t;
        } else {
          return {
            control: t.control,
            title: title._0,
            body: t.body,
            initialized: true,
            attempt: t.attempt,
            message: t.message,
            denied: t.denied
          };
        }
      case /* Loaded */ 3 :
        let control = title._0;
        const match = t.attempt;
        const match$1 = control.publication;
        const match$2 = match !== undefined ? (
            match$1 !== undefined ? (
                match.id === match$1.id && match.run_id === match$1.run_id ? [
                    undefined,
                    t.message
                  ] : [
                    undefined,
                    "Another publication was accepted. Review the current result."
                  ]
              ) : (
                Caml_obj.caml_notequal(match.run_id, control.run_id) ? [
                    undefined,
                    "The run changed. Review the current state before publishing again."
                  ] : [
                    match,
                    t.message
                  ]
              )
          ) : [
            match,
            t.message
          ];
        return {
          control: control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: match$2[0],
          message: match$2[1],
          denied: t.denied
        };
      case /* Started */ 4 :
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: title._0,
          message: "",
          denied: t.denied
        };
      case /* Delivery */ 5 :
        const phase = title._0;
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: Stdlib__Option.map((function (a) {
            return {
              id: a.id,
              run_id: a.run_id,
              version: a.version,
              title: a.title,
              body: a.body,
              phase
            };
          }), t.attempt),
          message: t.message,
          denied: t.denied
        };
      case /* Failed */ 6 :
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: undefined,
          message: title._0,
          denied: t.denied
        };
      case /* Message */ 7 :
        return {
          control: t.control,
          title: t.title,
          body: t.body,
          initialized: t.initialized,
          attempt: t.attempt,
          message: title._0,
          denied: t.denied
        };
    }
  }
}

function size(value) {
  return new TextEncoder().encode(value).byteLength;
}

function can_submit(t) {
  if (!t.denied && t.attempt === undefined && Stdlib__String.trim(t.title) !== "" && size(t.title) <= 256 && size(t.body) <= 60000 && !(Stdlib__String.contains(t.title, /* '\000' */0) || Stdlib__String.contains(t.body, /* '\000' */0))) {
    return Stdlib__Option.fold(false, (function (c) {
      if (c.run_id !== undefined && c.can_publish && c.publication === undefined) {
        return c.failure === undefined;
      } else {
        return false;
      }
    }), t.control);
  } else {
    return false;
  }
}

function body(attempt) {
  return JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "request_id",
      Mapre_wire__Json.str(attempt.id)
    ],
    tl: {
      hd: [
        "run_id",
        Mapre_wire__Json.str(attempt.run_id)
      ],
      tl: {
        hd: [
          "expected_version",
          attempt.version
        ],
        tl: {
          hd: [
            "title",
            Mapre_wire__Json.str(attempt.title)
          ],
          tl: {
            hd: [
              "body",
              Mapre_wire__Json.str(attempt.body)
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  }));
}

function progress(t) {
  const p = Stdlib__Option.bind(t.control, (function (c) {
    return c.publication;
  }));
  if (p !== undefined) {
    if (p.phase === "complete" && Caml_obj.caml_equal(p.receipt_state, "no_changes")) {
      return "No changes to publish.";
    } else if (p.phase === "complete" && p.pr === undefined) {
      return "Child branch published. Ready for parent integration.";
    } else if (p.phase === "complete") {
      return "Draft PR ready.";
    } else if (p.uncertain) {
      return "Publication is being reconciled. Do not start another publication.";
    } else if (p.phase === "waiting_turn") {
      return "Publication accepted. Waiting for the current response to finish.";
    } else {
      return "Publishing changes...";
    }
  }
  const match = t.attempt;
  if (match === undefined) {
    if (Stdlib__Option.fold(false, (function (c) {
        return c.branch_only;
      }), t.control)) {
      return "Publish this child branch for integration by its parent.";
    } else {
      return "Publish the confirmed changes to a branch and create a draft PR.";
    }
  }
  switch (match.phase) {
    case /* Sending */ 0 :
      return "Submitting publication...";
    case /* Uncertain */ 1 :
      return "Publication delivery is uncertain. Refresh or retry the same request.";
    case /* Accepted */ 2 :
      return "Publishing changes...";
  }
}

const initial = {
  control: undefined,
  title: "",
  body: "",
  initialized: false,
  attempt: undefined,
  message: "",
  denied: false
};

export {
  initial,
  update,
  decode,
  decode_publication,
  can_submit,
  body,
  progress,
}
/* Mapre_wire__Json Not a pure module */
